const PATH = {
  ROOT: '/',
  LOGIN: '/login',
  DASHBOARD: '/dashboard',
  CHANGE_PASSWORD: '/change-password',

  TABLE_TEST: '/table-test',
  FILTER_TEST: '/filter-test',
  DETAIL_TEST: '/detail-test',
  FORM_TEST: '/form-test',
  DND_TEST: '/dnd-test',
  CK_EDITOR_TEST: '/ck-editor-test',
  TABS_TEST: '/tabs-test',

  // notice page
  NOTICE_CREATE: '/notice/create',
  NOTICE_LIST: '/notice',
  NOTICE_DETAIL: '/notice/:id',
  NOTICE_EDIT: '/notice/edit/:id',

  // administator page
  ADMINISTRATOR_LIST: '/administrator',
  ADMINISTRATOR_CREATE: '/administrator/create',
  ADMINISTRATOR_DETAIL: '/administrator/:id',
  ADMINISTRATOR_EDIT: '/administrator/edit/:id',

  // faq page
  FAQ_CREAET: '/faq/create',
  FAQ_LIST: '/faq',
  FAQ_DETAIL: '/faq/:id',
  FAQ_EDIT: '/faq/edit/:id',

  // inquiry page
  INQUIRY_LIST: '/inquiry',
  INQUIRY_DETAIL: '/inquiry/:id',

  // customer page
  NORMAL_CUSTOMER_LIST: '/normal-customer',
  NORMAL_CUSTOMER_DETAIL: '/normal-customer/:id',
  BUSINESS_CUSTOMER_LIST: '/business-customer',
  BUSINESS_CUSTOMER_DETAIL: '/business-customer/:id',

  // main banner page
  MAIN_BANNER_CREATE: '/main-banner/create',
  MAIN_BANNER_LIST: '/main-banner',
  MAIN_BANNER_DETAIL: '/main-banner/:id',
  MAIN_BANNER_EDIT: '/main-banner/edit/:id',

  // sub banner page
  SUB_BANNER_CREATE: '/sub-banner/create',
  SUB_BANNER_LIST: '/sub-banner',
  SUB_BANNER_DETAIL: '/sub-banner/:id',
  SUB_BANNER_EDIT: '/sub-banner/edit/:id',

  // affiliate page
  PARTNERSHIP_COMPANIES_LIST: '/partnership-companies',
  PARTNERSHIP_LINKS_LIST: '/partnership-link',
  PARTNERSHIP_LINKS_DETAIL: '/partnership-link/:id',
  PARTNERSHIP_LINKS_EDIT: '/partnership-link/edit/:id',
  PARTNERSHIP_LINKS_CREATE: '/partnership-link/create',

  // recycling product page
  RECYCLING_PRODUCT_LIST: '/recycling-product',
  RECYCLING_PRODUCT_DETAIL: '/recycling-product/:id',
  RECYCLING_PRODUCT_CREATE: '/recycling-product/create',
  RECYCLING_PRODUCT_EDIT: '/recycling-product/edit/:id',
  // credit
  CREDIT_LIST: '/credit',

  // magazine
  MAGAZINE_CREATE: '/magazine/create',
  MAGAZINE_LIST: '/magazine',
  MAGAZINE_DETAIL: '/magazine/:id',
  MAGAZINE_EDIT: '/magazine/edit/:id',
  // recycling coupon
  RECYCLING_COUPON_CREATE: '/recycling-coupon/create',
  RECYCLING_COUPON_LIST: '/recycling-coupon',
  RECYCLING_COUPON_DETAIL: '/recycling-coupon/:id',
  RECYCLING_COUPON_EDIT: '/recycling-coupon/edit/:id',
  // recycling request
  RECYCLING_REQUESTS_LIST: '/recycling-requests',
  RECYCLING_REQUESTS_DETAIL: '/recycling-requests/:id',

  RECYCLING_PACKAGE_PRODUCTS: '/recycling-package-products',

  // community
  COMMUNITY_LIST: '/community',
  COMMUNITY_POSTING_DETAIL: '/community/posting/:id',
  COMMUNITY_COMMENT_DETAIL: '/community/comment/:id',
  COMMUNITY_REPORT_LIST: '/community-report',
  COMMUNITY_REPORT_DETAIL: '/community-report/:id',

  // push alarm
  PUSH_ALARM_LIST: '/push-alarm',
  PUSH_ALARM_DETAIL: '/push-alarm/:id',
  PUSH_ALARM_CREATE: '/push-alarm/create',
  PUSH_ALARM_EDIT: '/push-alarm/edit/:id',

  // Entry
  ENTRY_CREATE: '/entry/create',
  ENTRY_LIST: '/entry',
  ENTRY_DETAIL: '/entry/:id',
  ENTRY_EDIT: '/entry/edit/:id',

  // Donation
  DONATION_CREATE: '/donation/create',
  DONATION_LIST: '/donation',
  DONATION_DETAIL: '/donation/:id',
  DONATION_EDIT: '/donation/edit/:id',

  // Challenge
  CHALLENGE_CREATE: '/challenge/create',
  CHALLENGE_LIST: '/challenge',
  CHALLENGE_DETAIL: '/challenge/:id',
  CHALLENGE_EDIT: '/challenge/edit/:id',

  // AppHomeCotent
  APP_HOME_CONTENT_LIST: '/app-home-content',
  APP_HOME_CONTENT_CREATE: '/app-home-content/create',
  APP_HOME_CONTENT_DETAIL: '/app-home-content/:id',
  APP_HOME_CONTENT_EDIT: '/app-home-content/edit/:id',
};

export default PATH;
